import { useEffect } from "react";
import { useFileStore } from "../../store/useFileStore";
import { useDynamicDashboardData } from "../../context/dashboardDataContext";
import { getSlug } from "../../../../../../utils/getSlug";

const DocusaurusConfig = () => {
    // eslint-disable-next-line no-unused-vars
    const [_, setStore] = useFileStore((store) => store);

    const { projectInfo } = useDynamicDashboardData();

    useEffect(() => {
        let value = `// @ts-check
// \`@type\` JSDoc annotations allow editor autocompletion and type checking
// (when paired with \`@ts-check\`).
// There are various equivalent ways to declare your Docusaurus config.
// See: https://docusaurus.io/docs/api/docusaurus-config

import { themes as prismThemes } from "prism-react-renderer";

/** @type {import('@docusaurus/types').Config} */
const config = {
    title: "${projectInfo?.projectName}",
    tagline: "Admin dasboard for easy use.",
    favicon: "img/favicon.ico",

    // Set the production url of your site here
    url: "https://demo.reactadmin.com",
    // Set the /<baseUrl>/ pathname under which your site is served
    // For GitHub pages deployment, it is often '/<projectName>/'
    baseUrl: "/bootstrap/${getSlug(projectInfo?.projectName)}/docs/",

    // GitHub pages deployment config.
    // If you aren't using GitHub pages, you don't need these.
    organizationName: "React Admin", // Usually your GitHub org/user name.
    projectName: "${projectInfo?.projectName}", // Usually your repo name.

    onBrokenLinks: "throw",
    onBrokenMarkdownLinks: "warn",

    // Even if you don't use internationalization, you can use this field to set
    // useful metadata like html lang. For example, if your site is Chinese, you
    // may want to replace "en" with "zh-Hans".
    i18n: {
        defaultLocale: "en",
        locales: ["en"],
    },

    plugins: [require.resolve("docusaurus-lunr-search"), "docusaurus-plugin-sass"],

    // scripts: ["./src/css/custom.js"],

    // scripts: [
    //     // "https://docusaurus.io/script.js",
    //     "custom.js",
    //     // {
    //     //     src: "https://plausible.io/js/plausible.js",
    //     //     async: true,
    //     //     defer: true,
    //     //     "data-domain": "docs.plausible.io",
    //     // },
    // ],

    // clientModules: ["/notice.js", "/theme-mode.js"],
    clientModules: ["./static/notice.js"],

    presets: [
        [
            "classic",
            /** @type {import('@docusaurus/preset-classic').Options} */
            ({
                docs: {
                    routeBasePath: "/",
                    sidebarPath: "./sidebars.js",
                    // Please change this to your repo.
                    // Remove this to remove the "edit this page" links.
                    // editUrl:
                    //     "https://github.com/facebook/docusaurus/tree/main/packages/create-docusaurus/templates/shared/",
                },
                blog: false,
                theme: {
                    // customCss: "./src/css/custom.css",
                    customCss: [
                        "./node_modules/bootstrap/dist/css/bootstrap.min.css",
                        "./src/css/custom.css",
                    ],
                },
            }),
        ],
    ],

    themeConfig:
        /** @type {import('@docusaurus/preset-classic').ThemeConfig} */
        ({
            // Replace with your project's social card
            // image: "img/docusaurus-social-card.jpg",
            navbar: {
                // title: "React Admin",
                logo: {
                    srcDark: "img/white-logo.png",
                    alt: "React Admin Logo",
                    src: "img/black-logo.png",
                },
                items: [
                    // {
                    //     type: "docSidebar",
                    //     sidebarId: "tutorialSidebar",
                    //     position: "left",
                    //     label: "Tutorial",
                    // },
                    {
                        type: "html",
                        // href: "https://github.com/facebook/docusaurus",
                        // label: "Git",
                        position: "right",
                        value: \`<a href="https://reactadmin.com/${getSlug(
                            projectInfo?.projectName
                        )}" target="_blank" class="buy_now">Buy Now</a>\`,
                    },
                    {
                        type: "html",
                        // href: "https://github.com/facebook/docusaurus",
                        // label: "Git",
                        position: "right",
                        value: \`<a href="https://github.com/reactadmins/bootstrap-${getSlug(
                            projectInfo?.projectName
                        )}" target="_blank" class="navbar_github"></a>\`,
                    },
                    
                    // {
                    //     type: "html",
                    //     position: 'right',
                    //     value: \`<div class="light-dark-wrapper">
                    //                 <div class="mode-icon">
                    //                     <svg viewBox="0 0 24 24" width="24" height="24" class="darkIcon"><path fill="currentColor" d="M9.37,5.51C9.19,6.15,9.1,6.82,9.1,7.5c0,4.08,3.32,7.4,7.4,7.4c0.68,0,1.35-0.09,1.99-0.27C17.45,17.19,14.93,19,12,19 c-3.86,0-7-3.14-7-7C5,9.07,6.81,6.55,9.37,5.51z M12,3c-4.97,0-9,4.03-9,9s4.03,9,9,9s9-4.03,9-9c0-0.46-0.04-0.92-0.1-1.36 c-0.98,1.37-2.58,2.26-4.4,2.26c-2.98,0-5.4-2.42-5.4-5.4c0-1.81,0.89-3.42,2.26-4.4C12.92,3.04,12.46,3,12,3L12,3z"></path></svg>
                    //                     <svg viewBox="0 0 24 24" width="24" height="24" class="lightIcon"><path fill="currentColor" d="M12,9c1.65,0,3,1.35,3,3s-1.35,3-3,3s-3-1.35-3-3S10.35,9,12,9 M12,7c-2.76,0-5,2.24-5,5s2.24,5,5,5s5-2.24,5-5 S14.76,7,12,7L12,7z M2,13l2,0c0.55,0,1-0.45,1-1s-0.45-1-1-1l-2,0c-0.55,0-1,0.45-1,1S1.45,13,2,13z M20,13l2,0c0.55,0,1-0.45,1-1 s-0.45-1-1-1l-2,0c-0.55,0-1,0.45-1,1S19.45,13,20,13z M11,2v2c0,0.55,0.45,1,1,1s1-0.45,1-1V2c0-0.55-0.45-1-1-1S11,1.45,11,2z M11,20v2c0,0.55,0.45,1,1,1s1-0.45,1-1v-2c0-0.55-0.45-1-1-1C11.45,19,11,19.45,11,20z M5.99,4.58c-0.39-0.39-1.03-0.39-1.41,0 c-0.39,0.39-0.39,1.03,0,1.41l1.06,1.06c0.39,0.39,1.03,0.39,1.41,0s0.39-1.03,0-1.41L5.99,4.58z M18.36,16.95 c-0.39-0.39-1.03-0.39-1.41,0c-0.39,0.39-0.39,1.03,0,1.41l1.06,1.06c0.39,0.39,1.03,0.39,1.41,0c0.39-0.39,0.39-1.03,0-1.41 L18.36,16.95z M19.42,5.99c0.39-0.39,0.39-1.03,0-1.41c-0.39-0.39-1.03-0.39-1.41,0l-1.06,1.06c-0.39,0.39-0.39,1.03,0,1.41 s1.03,0.39,1.41,0L19.42,5.99z M7.05,18.36c0.39-0.39,0.39-1.03,0-1.41c-0.39-0.39-1.03-0.39-1.41,0l-1.06,1.06 c-0.39,0.39-0.39,1.03,0,1.41s1.03,0.39,1.41,0L7.05,18.36z"></path></svg>
                    //                 </div>
                    //                 <div class="light-dark-dropdown">
                    //                     <button class="light">
                    //                         <svg viewBox="0 0 24 24" width="24" height="24" class="lightIcon"><path fill="currentColor" d="M12,9c1.65,0,3,1.35,3,3s-1.35,3-3,3s-3-1.35-3-3S10.35,9,12,9 M12,7c-2.76,0-5,2.24-5,5s2.24,5,5,5s5-2.24,5-5 S14.76,7,12,7L12,7z M2,13l2,0c0.55,0,1-0.45,1-1s-0.45-1-1-1l-2,0c-0.55,0-1,0.45-1,1S1.45,13,2,13z M20,13l2,0c0.55,0,1-0.45,1-1 s-0.45-1-1-1l-2,0c-0.55,0-1,0.45-1,1S19.45,13,20,13z M11,2v2c0,0.55,0.45,1,1,1s1-0.45,1-1V2c0-0.55-0.45-1-1-1S11,1.45,11,2z M11,20v2c0,0.55,0.45,1,1,1s1-0.45,1-1v-2c0-0.55-0.45-1-1-1C11.45,19,11,19.45,11,20z M5.99,4.58c-0.39-0.39-1.03-0.39-1.41,0 c-0.39,0.39-0.39,1.03,0,1.41l1.06,1.06c0.39,0.39,1.03,0.39,1.41,0s0.39-1.03,0-1.41L5.99,4.58z M18.36,16.95 c-0.39-0.39-1.03-0.39-1.41,0c-0.39,0.39-0.39,1.03,0,1.41l1.06,1.06c0.39,0.39,1.03,0.39,1.41,0c0.39-0.39,0.39-1.03,0-1.41 L18.36,16.95z M19.42,5.99c0.39-0.39,0.39-1.03,0-1.41c-0.39-0.39-1.03-0.39-1.41,0l-1.06,1.06c-0.39,0.39-0.39,1.03,0,1.41 s1.03,0.39,1.41,0L19.42,5.99z M7.05,18.36c0.39-0.39,0.39-1.03,0-1.41c-0.39-0.39-1.03-0.39-1.41,0l-1.06,1.06 c-0.39,0.39-0.39,1.03,0,1.41s1.03,0.39,1.41,0L7.05,18.36z"></path></svg>
                    //                         <span>Light</span>
                    //                     </button>
                    //                     <button class="dark">
                    //                         <svg viewBox="0 0 24 24" width="24" height="24" class="darkIcon"><path fill="currentColor" d="M9.37,5.51C9.19,6.15,9.1,6.82,9.1,7.5c0,4.08,3.32,7.4,7.4,7.4c0.68,0,1.35-0.09,1.99-0.27C17.45,17.19,14.93,19,12,19 c-3.86,0-7-3.14-7-7C5,9.07,6.81,6.55,9.37,5.51z M12,3c-4.97,0-9,4.03-9,9s4.03,9,9,9s9-4.03,9-9c0-0.46-0.04-0.92-0.1-1.36 c-0.98,1.37-2.58,2.26-4.4,2.26c-2.98,0-5.4-2.42-5.4-5.4c0-1.81,0.89-3.42,2.26-4.4C12.92,3.04,12.46,3,12,3L12,3z"></path></svg>
                    //                         <span>Dark</span>
                    //                     </button>
                    //                     <button class="system">
                    //                         <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="systemIcon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-laptop mr-2 size-4"><path d="M20 16V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v9m16 0H4m16 0 1.28 2.55a1 1 0 0 1-.9 1.45H3.62a1 1 0 0 1-.9-1.45L4 16"></path></svg>
                    //                         <span>System</span>
                    //                     </button>
                    //                 </div>
                    //             </div>\`
                    // },
                ],
            },
            footer: {
                style: "dark",
                links: [
                    {
                        title: "Templates",
                        items: [
                            {
                                label: "Bootstrap",
                                to: "#",
                            },
                            {
                                label: "Tailwind",
                                to: "#",
                            },
                            {
                                html: \`
                                <div id="notice-root"></div>
                              \`,
                            },
                        ],
                    },
                    {
                        title: "Resources",
                        items: [
                            {
                                label: "Github",
                                href: "https://github.com/reactadmins/bootstrap-${getSlug(
                                    projectInfo?.projectName
                                )}",
                            },
                            {
                                label: "Support",
                                href: "https://www.reactadmin.com/dashboard/support",
                                target: '_blank'
                            },
                            {
                                label: "Buy Now",
                                href: "https://reactadmin.com/${getSlug(
                                    projectInfo?.projectName
                                )}",
                            },
                        ],
                    },
                    // {
                    //     title: "More",
                    //     items: [
                    //         {
                    //             label: "Blog",
                    //             to: "/blog",
                    //         },
                    //         {
                    //             label: "GitHub",
                    //             href: "https://github.com/facebook/docusaurus",
                    //         },
                    //     ],
                    // },
                ],
                copyright: \`Copyright © ${new Date().getFullYear()} ${
            projectInfo?.projectName
        }.\`,
            },
            prism: {
                theme: prismThemes.github,
                darkTheme: prismThemes.dracula,
            },
            // colorMode: {
            //     defaultMode: 'light',
            //     disableSwitch: false,
            //     respectPrefersColorScheme: true,
            // },
        }),
};

export default config;`;

        setStore({ docDocusaurusConfig: value });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [projectInfo?.projectName]);

    return null;
};

export default DocusaurusConfig;
